import React, { memo } from "react";

const PriceItem = memo(function PriceItem({ item, tabName, onClickBuy, onClickSell }) {
  const GRAM_FACTOR = 4.3318;

  // فرمت اعداد به فارسی
  const formatPrice = (value) => {
    if (!value) return null;
    return Number(value).toLocaleString('fa-IR');
  };

  const formatPricePerGram = (value) => {
    if (!value) return null;
    return Math.round(Number(value)).toLocaleString('fa-IR');
  };

  const calculatePricePerGram = (value) => {
    const numberValue = Number(value);
    return numberValue > 0 ? numberValue / GRAM_FACTOR : 0;
  };

  const showPerGram = tabName === "آبشده";
  const valueBuyPerGram = calculatePricePerGram(item.valueBuy);
  const valueSellPerGram = calculatePricePerGram(item.valueSell);

  return (
    <div className="ItemBlock">
      <div className="RowItem">
        {/* نام آیتم */}
        <p className="Item2 Bold cursor-pointer hover:text-blue-500 transition-colors">
          {item.title}
        </p>

        {/* دکمه فروش (اگر فعال باشد) */}
        {item.sell && item.valueSell ? (
          <p 
            className="Item2 cursor-pointer "
            onClick={() => onClickBuy(item)} // خرید از ما با نرخ فروش
            style={{ color: "#000" }}
          >
           {formatPrice(item.valueSell)}
          </p>
        ) : (
          <span className="disAble" style={{ color: "#fff", fontSize: "0.9em" , backgroundColor: "#ccc", width: "100%", textAlign: "center", maxWidth:"170px" }}>غیر فعال</span>
        )}

        {/* دکمه خرید (اگر فعال باشد) */}
        {item.buy && item.valueBuy ? (
          <p 
            className="Item2 cursor-pointer hover:text-green-400 transition-colors"
            onClick={() => onClickSell(item)} // فروش به ما با نرخ خرید
            style={{ color: "#000" }}
          >
           {formatPrice(item.valueBuy)}
          </p>
        ) : (
          <span className="disAble" style={{ color: "#fff", fontSize: "0.9em" , backgroundColor: "#ccc", width: "100%", textAlign: "center", maxWidth:"170px" }}>غیر فعال</span>
        )}
      </div>

      {/* نرخ هر گرم */}
      {showPerGram && (
      <div style={{ display: "flex", gap: "20px", fontSize: "12px", marginTop: "-5px", justifyContent: "space-between" }}>
        {item.sell && valueSellPerGram > 0 && (
          <p style={{ color: "#fff" }}>
            <span style={{ color: "#fff" }}>نرخ گرم (خرید):</span>{" "}
            {formatPricePerGram(valueSellPerGram)} ریال
          </p>
        )}
        {item.buy && valueBuyPerGram > 0 && (
          <p style={{ color: "#fff" }}>
            <span style={{ color: "#fff" }}>نرخ گرم (فروش):</span>{" "}
            {formatPricePerGram(valueBuyPerGram)} ریال
          </p>
        )}
      </div>
      )}
    </div>
  );
});

export default PriceItem;
